import React, { useEffect, useState } from 'react';
import { formatDateForOffset, formatMoney, convertModelDatesToUTCFromOperator } from '../../shared/Functions';
import { ReportsVService, PaymentProcessStatus } from '../../../services/V2/gozer';
import { TransactionsVService, AllowedAction, PaymentTypeEnum, PaymentTransactionTypeEnum } from '../../../services/V3/gozer';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import ReplyIcon from '@material-ui/icons/Reply';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import { getPaymentListings } from '../../shared/ExportFunctions';
import { CustomTable } from '../../shared/CustomTable';
import { TransferPayment } from './TransferPayment';
import { PaymentStatuses } from '../../../services/PaymentStatuses';
import { PaymentChannels } from '../../../services/PaymentChannels';
import { CreditCardTypes } from '../../../services/CreditCardTypes';
import { PaymentMethodTypes } from '../../../services/PaymentMethodTypes';

export const PaymentReportList = ({ model, errorToast, successToast, operatorId, offsetInMinutes }) => {
	const [hiddenColumns, setHiddenColumns] = useState([]);
	const [refresh, setRefresh] = useState<boolean>(true);
	const [showVoidRefund, setShowVoidRefund] = useState<boolean>(false);
	const [transaction, setTransaction] = useState<any>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [downloading, setDownloading] = useState<boolean>(false);
	const [showTransfer, setShowTransfer] = useState<boolean>(false);
	const [voidNotification, setVoidNotification] = useState<boolean>(false);

	useEffect(() => {
		setVoidNotification(false);
	}, [showVoidRefund]);

	const voidRefund = () => {
		setLoading(true)
		TransactionsVService
			.transactionsVVoidRefund(transaction.billingAccountId, transaction.transactionId, transaction.paymentAmount, voidNotification)
			.then(x => {
				setRefresh(true)
				successToast(`${transaction.allowedAction} request approved`)
				setShowVoidRefund(false)
				setLoading(false)
			})
			.catch(x => {
				errorToast(`${transaction.allowedAction} request declined. Please contact customer support for assistance.`)
				setLoading(false)
			})
	}

	const handleDownload = () => {
		getPaymentListings(model, new Date().toLocaleString(), setDownloading, offsetInMinutes)
	}

	const formatAmountByType = (value, transType, processStatus) => {
		let amount = 0;
		amount = (transType !== PaymentTransactionTypeEnum.CHARGE && processStatus !== PaymentProcessStatus.PENDING && value > 0) ? value * -1 : value;
		return formatMoney(amount) || '-'
	}

	const isFunded = (row) => {
		return new Date() >= new Date(row.fundingDate)
	}

	return (
		<div>
			{showTransfer &&
				<TransferPayment
					setShowTransfer={setShowTransfer}
					transaction={transaction}
					errorToast={errorToast}
					successToast={successToast}
					operatorId={operatorId}
					setRefresh={setRefresh}
				/>
			}
			{showVoidRefund &&
				<Dialog
					fullWidth
					open={true}
					onClose={() => setShowVoidRefund(false)}
					aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title">
						{transaction.allowedAction === AllowedAction.REFUND ? <ReplyIcon style={{ color: "#5bc058" }} /> : <ClearIcon style={{ color: "red" }} />} {transaction.allowedAction} Transaction
					</DialogTitle>
					<DialogContent>
						<Grid container>
							<Grid item xs={6} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Account</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "150px", textAlign: "left" }}>{transaction.account}</div>
									</label>
								</div>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Name</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "150px", textAlign: "left" }}>{transaction.name}</div>
									</label>
								</div>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Service Address</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "150px", textAlign: "left" }}>{transaction.serviceAddress?.street}</div>
									</label>
								</div>
							</Grid>
							<Grid item xs={6} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "100px", textAlign: "left" }}>{formatMoney(transaction.paymentAmount)}</div>
									</label>
								</div>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Payment Type</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "100px", textAlign: "left" }}>{transaction.paymentMethod}</div>
									</label>
								</div>
								<div style={{ display: "flex" }}>
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Payment Date</b><span>&nbsp;:&nbsp;</span>
										<div style={{ width: "100px", textAlign: "left" }}>{formatDateForOffset(transaction.paymentDate, offsetInMinutes)}</div>
									</label>
								</div>
							</Grid>
							<Grid item xs={6} style={{ marginTop: "20px" }}></Grid>
							<Grid item xs={6} style={{ marginTop: "20px" }}>
								{transaction.allowedAction === AllowedAction.VOID &&
									<label className='uvp-label' style={{ display: "flex" }}>
										<b>Send Void Notification</b><span>&nbsp;:&nbsp;</span>
										<input type='checkbox' onChange={() => setVoidNotification(!voidNotification)} checked={voidNotification} />
									</label>
								}
							</Grid>

						</Grid>
					</DialogContent>
					<DialogActions>
						<button
							className='uvp-button green-button'
							onClick={() => voidRefund()}
							color="primary">
							Submit {transaction.allowedAction}
						</button>
						<button className='uvp-button gray-button' onClick={() => setShowVoidRefund(false)}>
							Close
						</button>
					</DialogActions>
				</Dialog>
			}
			<Grid container style={{ display: "flex", justifyContent: "flex-end", margin: "30px 0px 20px 0px", padding: "0px", fontSize: "14px" }}>
				<Grid item xs={1}>
					{downloading && <CircularProgress size={'1em'} style={{ marginRight: "5px" }} />}
					<b>Download</b>&nbsp;:&nbsp;<Link onClick={handleDownload} className="clickable">csv</Link>
				</Grid>
			</Grid>
			<CustomTable
				columns={[
					{ title: 'Batch Number', field: 'batchNumber', render: rowData => rowData.batchNumber || '-' },
					{ title: 'District', field: 'district', render: rowData => rowData.district || '-' },
					{ title: 'Account', field: 'accountNumber', render: rowData => rowData.account || '-' },
					{ title: 'Name', field: 'name', render: rowData => rowData.name || '-' },
					{ title: 'Service Address', field: 'serviceAddress', render: rowData => rowData.serviceAddress?.street || '-' },
					{ title: 'Payment Date', field: 'paymentDate', render: rowData => rowData.paymentDate ? formatDateForOffset(rowData.paymentDate, offsetInMinutes) : '-' },
					{ title: 'Payment Amount', field: 'paymentAmount', render: rowData => formatAmountByType(rowData.paymentAmount, rowData.paymentTransactionType, rowData.paymentStatus) },
					{ title: 'Service Fee', field: 'feeAmount', render: rowData => formatAmountByType(rowData.feeAmount, rowData.paymentTransactionType, rowData.paymentStatus) },
					{
						title: 'Payment Status',
						field: 'paymentStatus',
						render: rowData => (rowData.paymentStatus === 'Chargeback' || rowData.paymentStatus === 'ACH Return') ? rowData.paymentStatus :
							(rowData.fundingDate && rowData.paymentTransactionType === PaymentTransactionTypeEnum.CHARGE && isFunded(rowData)) ? PaymentProcessStatus.FUNDED :
								PaymentStatuses.find(x => x.value === rowData.paymentStatus && x.paymentTransactionType === rowData.paymentTransactionType)?.name || '-'
					},
					{ title: 'Decline Reason', field: 'declineReason', render: rowData => rowData.declinedReason || '-' },
					{
						title: 'Payment Type',
						field: 'paymentType',
						render: rowData => (
							PaymentMethodTypes.find(x => x.value === rowData.paymentMethod)?.name
						) || '-'
					},
					{
						title: 'Card Type',
						field: 'paymentType',
						render: rowData => (
							rowData.paymentMethod === PaymentTypeEnum.CC && rowData.cardType && CreditCardTypes.find(x => x.value === rowData.cardType)?.name
						) || '-'
					},
					{ title: 'Last 4', field: 'last4', render: rowData => rowData.last4 || '-' },
					{ title: 'Confirmation Number', field: 'confirmationNumber', render: rowData => rowData.confirmationNumber || '-' },
					{ title: 'Payment Source', field: 'source', render: rowData => PaymentChannels.find(x => x.channels.includes(rowData.source))?.name || '-' },
					{ title: 'Posting Date', field: 'postingDate', render: rowData => rowData.postingDate ? formatDateForOffset(rowData.postingDate, offsetInMinutes) : '-' },
					{ title: 'Funding Group', field: 'fundingGroup', render: rowData => rowData.fundingGroup || '-' },
					{ title: 'Funding Date', field: 'fundingDate', render: rowData => rowData.fundingDate && rowData.fundingGroup && rowData.fundingAmount ? new Date(rowData.fundingDate).toLocaleDateString() : '-' },
					{ title: 'Funding Amount', field: 'fundingAmount', render: rowData => rowData.fundingAmount ? formatMoney(rowData.fundingAmount) : '-' },
					{ title: 'Return Date', field: 'returnDate', render: rowData => rowData.returnDate ? formatDateForOffset(rowData.returnDate, offsetInMinutes) : '-' }
				]}
				pageSize={15}
				enablePaging={false}
				actions={[
					{
						icon: (rowData) => <>
							{rowData.allowedAction === AllowedAction.REFUND && isFunded(rowData) &&
								<ReplyIcon />}
						</>,
						tooltip: "Refund Payment",
						onClick: (rowData: any, index: any) => {
							setTransaction(rowData);
							setShowVoidRefund(true);
						},
						disabled: (rowData) => rowData.paymentStatus !== "Approved" && rowData.paymentStatus !== "Funded"
					},
					{
						icon: (rowData) => <>
							{rowData.allowedAction === AllowedAction.VOID &&
								<ClearIcon />}
						</>,
						tooltip: "Void Payment",
						onClick: (rowData: any, index: any) => {
							setTransaction(rowData);
							setShowVoidRefund(true);
						},
						disabled: (rowData) => rowData.paymentStatus !== "Approved" && rowData.paymentStatus !== "Funded"
					},
					{
						icon: (rowData) => <>
							{rowData.paymentTransactionType === PaymentTransactionTypeEnum.CHARGE &&
								<SyncAltIcon />}
						</>,
						tooltip: "Transfer Payment",
						onClick: (rowData: any, index: any) => {
							setTransaction(rowData);
							setShowTransfer(true);
						},
						disabled: (rowData) => rowData.paymentStatus !== "Approved" && rowData.paymentStatus !== "Funded"
					}
				]}
				hiddenColumns={hiddenColumns}
				setHiddenColumns={setHiddenColumns}
				hiddenColumnsDisabled={false}
				refresh={refresh}
				setRefresh={setRefresh}
				dataEndpoint={(query) => {
					return new Promise((resolve, reject) => {
						const offset = offsetInMinutes;
						const sendModel = convertModelDatesToUTCFromOperator(model, offset);
						ReportsVService.reportsVGetPaymentListings(query.pageNumber - 1, sendModel)
							.then(x => resolve(x)).catch(x => reject(x));
					});
				}}
				dataSet={null}
				title={""}
				districtId={null}
				addedQuery={null}
				tableHeight={"420px"}
				enableSearch={false}
				searchPlaceholder={null} />
			{loading &&
				<div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
			}
		</div>
	);
};